import { useL10n } from '@uplift/hooks';
import { EditableSectionContainer, EditableSectionRow } from '../../../EditableSection';
import { ChangePasswordForm, useChangePasswordForm } from './forms';


export const LoginSettingsSection: React.VFC<{ userId: string }> = ({ userId }) => {
  const l10n = useL10n();
  const { changePasswordFormik } = useChangePasswordForm(userId);

  return (
    <EditableSectionContainer
      title={l10n.providerSettings.login}
      formikConfigs={{
        password: changePasswordFormik
      }}
    >
      <EditableSectionRow
        label={l10n.providerSettings.password}
        rowKey="password"
        editButtonText={l10n.providerSettings.change}
        form={<ChangePasswordForm />}
        kind="editable-row"
        rowFormWrapperProps={{
          mobileModalTitle: l10n.providerSettings.changePassword
        }}
      />
    </EditableSectionContainer>
  );
};
